export default __webpack_public_path__ + "static/gamerize-4ee51629d0e29411c087a2c712e161b3.webp";